<template>
  <div class="full-width">
    <div class="img-part">
      <div class="img-box">
        <img :src="imgUrl">
      </div>
    </div>

    <div class="title-part">
      <span>{{productName}}</span>
    </div>
   <div style="text-align: left;">
    <div class="price-span">
      <span>${{ obj.curr}}{{ obj.cost}}</span>
    </div>
    <div class="des-part">
      <span>{{description}}</span>
    </div>
   </div>
    <div>
      <iframe :src="`${baseUrl.SSL}://${obj.procedurename}/Web/W006/productinfo.asp?productID=P00016&ProductCompanyCode=30290&CompanyCode=30290`" width="100%" height="360px" frameborder="0"></iframe>

    </div>
    <div class="operation-box">
<!--      <el-button type="primary" @click="addGoShopChart">{{i18n.tkey("lang_communicate")}}</el-button>-->
      &nbsp; <el-button plain type="primary"  @click="addGoShopChart"  ><font-awesome-icon style="height: 1.5em;color: #2e2c2c" icon="fa-solid fa-cart-shopping"  /></el-button>

<!--            <a :href="jumpUrl" target="web">
        <el-button tkey="查看">{{i18n.tkey("lang_check")}}</el-button>
      </a>-->
    </div>
  </div>
</template>

<script setup>

import {inject, toRef, computed} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import baseUrl from "@/request/base";

const props = defineProps(["obj"])
const emits = defineEmits(["clickaddGoShopChart"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const imgUrl = computed(() => {
  let url = ""

  if (null != props.obj){
    url = myUtil.generateProductImg(props.obj)
  }

  return url
})

const productName = computed(() => {
  let name = ""

  if (null != props.obj){
    name = props.obj.productnamecn

    if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
      name = props.obj.productname
    }
  }

  return name
})

const description = computed(() => {
  let des = ""

  if (null != props.obj){
    des = props.obj.description2

    if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
      des = props.obj.description
    }

  }

  return des
})

const jumpUrl = computed(() => {
  let url = "javascript: void(0)"

  if (null != props.obj){
    url = myUtil.generateEshopopeeProductPageUrl(props.obj)
  }

  return url
})

function addGoShopChart(){
  emits("clickaddGoShopChart", props.obj)
}

</script>

<style scoped>

.full-width {
  width: 100%;
  box-sizing: border-box;
}

.img-part {
  text-align: center;
}

.img-box {
  position: relative;
  width: 70%;
  padding-top: 70%;
  margin: auto;
}

.img-box img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: scale-down;
  box-sizing: border-box;
  border: 1px #F5F7FA solid;
}

.title-part {
  font-size: 14px;
//margin-bottom: 20px;
//margin-top: 20px;
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: 600;
  color: #303133;
}

.des-part {
  text-align: left;
  font-size: 12px;
  color: #606266;
  line-height: 2;
  width: 100%;
}
.price-span {
  color: #e83f33;
  font-weight: 600;
}
.operation-box {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

</style>